import { render, staticRenderFns } from "./EpayTypeForm.vue?vue&type=template&id=16c34836&"
import script from "./EpayTypeForm.vue?vue&type=script&lang=js&"
export * from "./EpayTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports